const NAME = "AUDIO_PLAYER";

export default NAME;
